import ApiService from '@/api/http/ApiService';
import { Auditing } from '@/interfaces/models/Auditing';
import { Page } from '@/interfaces/api/Page';
import Filter from '@/interfaces/api/Filter';
import { Pagination } from '@/interfaces/api/Pagination';
import axios, { AxiosPromise } from 'axios';

export default class AuditingApiService extends ApiService<Auditing> {
  constructor() {
    super('audit', 'v1');
  }

  public getAudits(page: Page, filter: Filter): AxiosPromise<Auditing[] | Pagination<Auditing>> {
    if (page) {
      return axios.get(`${this.getBaseUrl()}/`, {
        params: { page, limit: 10, ...(filter.venue ? { venue: filter.venue } : {}) },
      });
    }

    return axios.get(`${this.getBaseUrl()}/`);
  }
}
